import { PLACE_ATTRIBUTE } from "../design/place.js";

/**
 * Someone who has asked their machine to stop moving things gets the resting
 * state and nothing else. One reading, shared by every flourish that is
 * decided in code rather than in the stylesheet (the stylesheet has its own
 * `prefers-reduced-motion` guards).
 */
export function stillness(): boolean {
  return globalThis.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;
}

/**
 * THE STUDY'S MOTION (2026-11-02): the comet along a connection, the line
 * that lingers to be erased, the cross-fade at the threshold. They play only
 * in the study — the book stays quiet — and only when nothing has asked for
 * stillness. Read from the document root at the moment it matters, never
 * kept: the place changes with the route.
 */
export function studyMotion(): boolean {
  return !stillness() && globalThis.document.documentElement.getAttribute(PLACE_ATTRIBUTE) === "study";
}
